var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleMealPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5H9.58333C6.69497 17.5 5.25079 17.5 4.2236 16.7891C3.82787 16.5152 3.48481 16.1722 3.21093 15.7764C2.5 14.7493 2.5 13.3051 2.5 10.4167V10.4167C2.5 7.52834 2.5 6.08416 3.21093 5.05697C3.48481 4.66124 3.82787 4.31819 4.2236 4.0443C5.25079 3.33337 6.69497 3.33337 9.58333 3.33337H10C13.2875 3.33337 14.9312 3.33337 16.0376 4.24133C16.2401 4.40755 16.4258 4.59326 16.592 4.7958C17.5 5.90215 17.5 7.54589 17.5 10.8334V12.0834",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.5H17.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.5V4.38889M13.75 2.5V4.38889",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H17.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5V17.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleMealPlanIcon);
export default __webpack_public_path__ + "static/media/scheduleMealPlanIcon.54d2d0fdd1688ff387c01e921769ff40.svg";
export { ForwardRef as ReactComponent };